import { select, useDispatch } from '@ps/web-core-store';
import { canUseLocalStorage } from '@ps/web-core-utils';
import { ActiveGameType } from '@ps/web-poker-types';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { ACTIVE_GAMES_LOCAL_STORAGE_KEY } from '../../utils/constants';
import useOpenActiveGame from '../useOpenActiveGame';

const useTournamentTakeSeat = (id?: number) => {
  const { focusActiveGame } = useOpenActiveGame();
  const isEmbedded = useSelector(select.device.isEmbedded);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { modal } = useDispatch();

  return useCallback((): void => {
    if (!id) return;

    if (isEmbedded) {
      return window.starsweb?.app?.execute?.(`tournament/${id}`);
    }

    if (isAuthenticated) {
      if (canUseLocalStorage) {
        const currentOpenedActiveGames = JSON.parse(
          localStorage.getItem(ACTIVE_GAMES_LOCAL_STORAGE_KEY) ?? '[]'
        ) as number[];
        !currentOpenedActiveGames.includes(id) &&
          localStorage.setItem(
            ACTIVE_GAMES_LOCAL_STORAGE_KEY,
            JSON.stringify([...currentOpenedActiveGames, id])
          );
      }
      focusActiveGame({ id, type: ActiveGameType.Tourney });
    } else {
      modal.unshift({ path: '/auth/login' });
    }
  }, [id, isEmbedded, isAuthenticated, focusActiveGame, modal]);
};

export default useTournamentTakeSeat;
